import * as moment from 'moment';
import { useState, useEffect } from 'react';
import { AuthActionCreators } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { IDataComplianceIssues } from '@nkr/models/index';

interface IRetVal {
    results: IDataComplianceIssues | null,
    loading: boolean,
    error: string
}

const useDataComplianceIssues = (centerId: number, month: string): IRetVal => {
    const { dispatch } = useAppHookContext();

    const [results, setResults] = useState<IDataComplianceIssues | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);
        setError('');

        const fetchData = async () => {
            try {
                const response = await dispatch(AuthActionCreators.apiGet({
                    url: `${__API__}/report/data-compliance-issues?centerId=${centerId}&month=${month}`
                }));

                if (response && response.data.success) {
                    setResults(response.data.results);
                } else {
                    setError('Unable to load data compliance issues');
                }
            } catch (err) {
                setError('Unable to load data compliance issues');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [centerId, month]);

    return { results, loading, error };
};

export default useDataComplianceIssues;
